import { SurveyContent } from './SurveyComponents/SurveyContent';
import { SurveyProvider } from './Context/SurveyContext';

export default function MySurvey() {
    return (
        <SurveyProvider>
            <SurveyContent />
        </SurveyProvider>
    );
}